import { User } from '@repo/domain/user';
import type { Subscription } from '@repo/subscription/api';
import { BasicModalProps } from '@repo/ui/deprecated/Modal';

export enum FreeTrialOffboardingSteps {
  BenefitsOverview = 'BenefitsOverview',
  AreYouSure = 'AreYouSure',
  ReasonSelection = 'ReasonSelection',
  Confirmation = 'Confirmation',
}

interface ButtonProps<T> {
  label: string;
  onClick: (data: T) => void;
}

export interface OffboardingModalContentButtons<T = unknown, U = unknown> {
  primaryButton: ButtonProps<T>;
  secondaryButton?: ButtonProps<U>;
}

export interface OffboardingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (subscription: Subscription) => void;
  user: User;
  subscription: Subscription;
  backButtonLabel?: string;
  modalProps?: Omit<BasicModalProps, 'isOpen' | 'onClose'>;
  skipToCancel?: boolean;
}

export interface OffboardingModalContentProps
  extends Omit<OffboardingModalProps, 'isOpen'> {
  onStartLoading: () => void;
  onFinishLoading: () => void;
}

export enum GeneralOffboardingSteps {
  Questionnaire = 'Questionnaire',
  Congrats = 'Congrats',
  Roadmap = 'Roadmap',
  SwitchToMonthly = 'SwitchToMonthly',
  DiscountOffer = 'DiscountOffer',
  AreYouSure = 'AreYouSure',
}
